module.exports = __webpack_public_path__ + "media/images/lb/875-6c96b83f3331cfd137bdf9233a5428e6.svg";